import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse, OwnerType } from "types";

type useGidentifyOwnerReRunMutationProps = {
	id: number;
	onSuccessHandler?: Function;
	ownerType: OwnerType;
};

const useGidentifyOwnerReRunMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, ownerType }: useGidentifyOwnerReRunMutationProps) =>
			autoChecklistService.reRunGidentifyOwner(id, ownerType),
		{
			onSuccess(_, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "gIdentify re-run was successful",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGidentifyOwnerReRunMutation;
